var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHexa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2887 111.462L0.57735 60L30.2887 8.53848H89.7113L119.423 60L89.7113 111.462H30.2887Z",
    stroke: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7887 103.667L18.5774 60L43.7887 16.3327H94.2113L119.423 60L94.2113 103.667H43.7887Z",
    stroke: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2887 95.8731L36.5774 60L57.2887 24.1269H98.7113L119.423 60L98.7113 95.8731H57.2887Z",
    stroke: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7887 88.0788L54.5774 60L70.7887 31.9212H103.211L119.423 60L103.211 88.0788H70.7887Z",
    stroke: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2887 80.2846L72.5774 60L84.2887 39.7154H107.711L119.423 60L107.711 80.2846H84.2887Z",
    stroke: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7887 72.4904L90.5774 60L97.7887 47.5096H112.211L119.423 60L112.211 72.4904H97.7887Z",
    stroke: "#C6C6C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexa);
export default __webpack_public_path__ + "static/media/hexa.63bb0a57b3c5ab30ab78937af009dbcd.svg";
export { ForwardRef as ReactComponent };